import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门剧集精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选高分热门电视剧，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={`天美影视电视剧 ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-bold bg-primary-500 text-background-50 rounded-md">
                    {card.rating}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 text-xs font-medium bg-black/60 text-white rounded-md backdrop-blur-sm">
                    {card.status}
                  </span>
                </div>
              </div>

              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-base font-bold text-foreground-900 font-heading">
                    {card.title}
                  </h3>
                  <span className="text-xs text-foreground-400">{card.year}</span>
                </div>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded">
                    {card.genre}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}